import React, { useMemo } from "react";

const cardStyle = {
    marginTop: "10px",
    padding: "14px",
    borderRadius: "10px",
    border: "1px solid #d9e2db",
    background: "#f9fbf9",
};

const qrWrapperStyle = {
    display: "flex",
    gap: "14px",
    alignItems: "flex-start",
    flexWrap: "wrap",
};

const qrImageStyle = {
    width: "156px",
    height: "156px",
    borderRadius: "10px",
    border: "1px solid #d9e2db",
    background: "#ffffff",
    objectFit: "contain",
};

const buttonStyle = {
    borderRadius: "8px",
    border: "1px solid #1fac48",
    background: "#ffffff",
    color: "#1fac48",
    fontWeight: 600,
    padding: "8px 12px",
    cursor: "pointer",
};

const buildQrImageUrl = (value) =>
    `https://api.qrserver.com/v1/create-qr-code/?size=320x320&margin=10&data=${encodeURIComponent(
        value
    )}`;

const QrCodePreview = ({
    title = "Scan on your phone",
    targetUrl = "",
    helperText = "",
}) => {
    const qrImageUrl = useMemo(
        () => (targetUrl ? buildQrImageUrl(targetUrl) : ""),
        [targetUrl]
    );

    const handleCopy = async () => {
        if (!targetUrl || !navigator?.clipboard?.writeText) return;
        await navigator.clipboard.writeText(targetUrl);
    };

    if (!targetUrl) {
        return null;
    }

    return (
        <div style={cardStyle}>
            <div style={{ fontWeight: 700, color: "#111111", marginBottom: 10 }}>
                {title}
            </div>

            <div style={qrWrapperStyle}>
                <img
                    src={qrImageUrl}
                    alt="QR code for mobile handoff"
                    style={qrImageStyle}
                />

                <div style={{ flex: "1 1 220px", minWidth: "220px" }}>
                    <div
                        style={{
                            color: "#555555",
                            fontSize: 14,
                            lineHeight: 1.5,
                            marginBottom: 10,
                        }}
                    >
                        {helperText}
                    </div>

                    <div
                        style={{
                            fontSize: 12,
                            lineHeight: 1.5,
                            color: "#24513a",
                            wordBreak: "break-all",
                            marginBottom: 10,
                        }}
                    >
                        {targetUrl}
                    </div>

                    <button type="button" style={buttonStyle} onClick={handleCopy}>
                        Copy Link
                    </button>
                </div>
            </div>
        </div>
    );
};

export default QrCodePreview;
